export const SECTORS = [
  'Laser',
  'Limpeza',
  'Transfer',
  'Transferente',
  'Digital',
  'Tampografia',
  'Telas',
  'Manutenção',
  'Silk',
  'Manuseio',
  'Resina',
  'Plotter',
  'Acrílicos',
  'Desembalagem',
  'Produção',
  'Almoxarifado',
  '360',
];

export const SECTOR_OPTIONS = SECTORS.map((s) => ({ value: s, label: s }));
